angular.module('leave')
    .component('leaveDashboard', {
        bindings: {
        },
        templateUrl: 'app/leave/dashboard.html',
        controller: function ($scope, LeaveService, Principal, $http) {
            this.LeaveService = LeaveService

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_LEAVE_MANAGER"]).then(isManager => {
                    this.isManager = isManager
                    return Principal.hasAnyAuthorityPromise(["ROLE_LEAVE_MODULE"])
                }).then(isUser => {
                    this.isUser = isUser
                    if (this.isManager || this.isUser) {
                        this.loadStatistics()
                    } else {
                        this.data = null
                    }
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/leave/user-statistics').then(response => {
                    this.data = response.data;
                }).catch(() => {
                    this.data = null
                });
            }
        }
    })
